import { useSEO } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PoliticaCookiesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Política de Cookies | Consultadoria de Serviços em Saúde',
    description: 'Política de cookies da Consultadoria de Serviços em Saúde. Informações sobre como utilizamos cookies no nosso website.',
    keywords: 'política cookies, privacidade, proteção dados, RGPD',
    canonical: '/politica-cookies',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Política de Cookies',
      description: 'Política de cookies da Consultadoria de Serviços em Saúde',
      url: `${siteUrl}/politica-cookies`
    }
  });

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-24">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Cookies</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-PT')}
            </p>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">O que são Cookies?</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cookies são pequenos ficheiros de texto que são armazenados no seu dispositivo (computador, tablet ou telemóvel) quando visita um website. Os cookies permitem que o website reconheça o seu dispositivo e armazene algumas informações sobre as suas preferências ou ações passadas.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Como Utilizamos os Cookies</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Utilizamos cookies para melhorar a sua experiência no nosso website, permitindo-nos:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li>Manter as suas preferências e configurações</li>
                <li>Compreender como utiliza o nosso website</li>
                <li>Melhorar o desempenho e funcionalidade do site</li>
                <li>Personalizar o conteúdo apresentado</li>
                <li>Garantir a segurança do website</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Tipos de Cookies que Utilizamos</h2>
              
              <div className="space-y-6">
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <i className="ri-shield-check-line text-teal-600 mr-2"></i>
                    Cookies Estritamente Necessários
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Estes cookies são essenciais para o funcionamento do website e não podem ser desativados. São geralmente definidos em resposta a ações realizadas por si, como definir as suas preferências de privacidade, iniciar sessão ou preencher formulários.
                  </p>
                  <p className="text-sm text-gray-500">
                    <strong>Duração:</strong> Sessão ou até 1 ano
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <i className="ri-bar-chart-line text-teal-600 mr-2"></i>
                    Cookies de Desempenho e Análise
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Estes cookies permitem-nos contar visitas e fontes de tráfego para que possamos medir e melhorar o desempenho do nosso site. Ajudam-nos a saber quais as páginas mais e menos populares e a ver como os visitantes se movem pelo site.
                  </p>
                  <p className="text-sm text-gray-500">
                    <strong>Duração:</strong> Até 2 anos
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <i className="ri-settings-3-line text-teal-600 mr-2"></i>
                    Cookies de Funcionalidade
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Estes cookies permitem que o website forneça funcionalidades melhoradas e personalização. Podem ser definidos por nós ou por fornecedores terceiros cujos serviços adicionámos às nossas páginas.
                  </p>
                  <p className="text-sm text-gray-500">
                    <strong>Duração:</strong> Até 1 ano
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <i className="ri-chat-3-line text-teal-600 mr-2"></i>
                    Cookies do Assistente Virtual
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Utilizamos cookies para o funcionamento do nosso assistente virtual (Readdy Agent), que permite agendar consultas e responder às suas questões. Estes cookies armazenam as suas preferências de conversação e histórico de interações.
                  </p>
                  <p className="text-sm text-gray-500">
                    <strong>Duração:</strong> Até 1 ano
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies de Terceiros</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Alguns cookies são colocados por serviços de terceiros que aparecem nas nossas páginas. Não controlamos estes cookies e recomendamos que consulte os websites destes terceiros para mais informações:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
                <li><strong>Readdy Agent:</strong> Assistente virtual para agendamento e suporte</li>
                <li><strong>Google Fonts:</strong> Fontes tipográficas</li>
                <li><strong>Font Awesome / Remix Icon:</strong> Ícones do website</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Como Gerir os Cookies</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Pode controlar e/ou eliminar cookies como desejar. Pode eliminar todos os cookies que já estão no seu dispositivo e pode configurar a maioria dos navegadores para impedir que sejam colocados.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                No entanto, se o fizer, poderá ter de ajustar manualmente algumas preferências sempre que visitar um site e alguns serviços e funcionalidades poderão não funcionar.
              </p>
              
              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-lg mb-6">
                <h4 className="font-bold text-gray-900 mb-2">Como desativar cookies no seu navegador:</h4>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li><strong>Chrome:</strong> Definições → Privacidade e segurança → Cookies</li>
                  <li><strong>Firefox:</strong> Opções → Privacidade e Segurança → Cookies</li>
                  <li><strong>Safari:</strong> Preferências → Privacidade → Cookies</li>
                  <li><strong>Edge:</strong> Definições → Cookies e permissões do site</li>
                </ul>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Consentimento</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Ao utilizar o nosso website, consente a utilização de cookies de acordo com esta política. Quando visita o nosso site pela primeira vez, é apresentado um banner de cookies que lhe permite aceitar ou recusar cookies não essenciais.
              </p>
              <p className="text-gray-600 leading-relaxed mb-4">
                Pode alterar as suas preferências de cookies a qualquer momento através das definições do seu navegador.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Atualizações desta Política</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Podemos atualizar esta Política de Cookies periodicamente para refletir mudanças nas nossas práticas ou por outros motivos operacionais, legais ou regulamentares. Recomendamos que reveja esta página regularmente para se manter informado sobre como utilizamos cookies.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Contacte-nos</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Se tiver questões sobre a nossa utilização de cookies, pode contactar-nos através de:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <i className="ri-mail-line text-teal-600 text-xl"></i>
                    <a href="mailto:consultadoriaeservicosemsaude@gmail.com" className="text-gray-900 hover:text-teal-600 transition-colors">
                      consultadoriaeservicosemsaude@gmail.com
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-phone-line text-teal-600 text-xl"></i>
                    <a href="tel:919214659" className="text-gray-900 hover:text-teal-600 transition-colors">
                      919 214 659
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <div className="bg-teal-600 text-white p-6 rounded-lg">
              <p className="text-sm leading-relaxed">
                <strong>Nota:</strong> Esta política de cookies está em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) e a legislação portuguesa aplicável.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}